import { type ReactNode, useId, useState } from 'react';

import { Btn } from './Btn';

/** Keep filters mounted so values survive folding and viewport changes. */
export function FilterBar({
  children,
  compact = false,
}: {
  children: ReactNode;
  compact?: boolean;
}) {
  const [open, setOpen] = useState(false);
  const id = useId();
  return (
    <div className="mb-6 min-w-0">
      <div className="sm:hidden mb-3">
        <Btn
          aria-expanded={open}
          aria-controls={id}
          onClick={() => setOpen((value) => !value)}
        >
          ตัวกรอง <span aria-hidden="true">{open ? '−' : '+'}</span>
        </Btn>
      </div>
      <div
        id={id}
        className={`${open ? 'flex' : 'hidden'} sm:flex flex-wrap items-end gap-3 rounded-card border border-line bg-surface p-4 ${compact ? '[&>*]:w-full sm:[&>*]:w-60' : '[&>*]:min-w-0 [&>*]:max-w-full'}`}
      >
        {children}
      </div>
    </div>
  );
}
